 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"chart-js":"chart-js","default~abp-ng-identity~abp-ng-setting-management~abp-ng-tenant-management":"default~abp-ng-identity~abp-ng-setting-management~abp-ng-tenant-management","abp-ng-identity":"abp-ng-identity","abp-ng-setting-management":"abp-ng-setting-management","abp-ng-tenant-management":"abp-ng-tenant-management","default~features-modules-authorize-authorize-module~features-modules-contest-contest-module~features~cae43e94":"default~features-modules-authorize-authorize-module~features-modules-contest-contest-module~features~cae43e94","default~features-modules-authorize-authorize-module~features-modules-page-page-module":"default~features-modules-authorize-authorize-module~features-modules-page-page-module","features-modules-authorize-authorize-module":"features-modules-authorize-authorize-module","features-modules-page-page-module":"features-modules-page-page-module","default~features-modules-contest-contest-module~features-modules-leaderboard-leaderboard-module~feat~674cbcd3":"default~features-modules-contest-contest-module~features-modules-leaderboard-leaderboard-module~feat~674cbcd3","default~features-modules-contest-contest-module~features-modules-problem-problem-module~features-mod~92c31d0b":"default~features-modules-contest-contest-module~features-modules-problem-problem-module~features-mod~92c31d0b","default~features-modules-contest-contest-module~features-modules-problem-problem-module~features-mod~21de2aef":"default~features-modules-contest-contest-module~features-modules-problem-problem-module~features-mod~21de2aef","default~features-modules-contest-contest-module~features-modules-problem-problem-module":"default~features-modules-contest-contest-module~features-modules-problem-problem-module","common":"common","features-modules-problem-problem-module":"features-modules-problem-problem-module","default~features-modules-contest-contest-module~features-modules-training-training-module":"default~features-modules-contest-contest-module~features-modules-training-training-module","features-modules-contest-contest-module":"features-modules-contest-contest-module","features-modules-training-training-module":"features-modules-training-training-module","default~features-modules-profile-profile-module~features-modules-team-team-module":"default~features-modules-profile-profile-module~features-modules-team-team-module","features-modules-profile-profile-module":"features-modules-profile-profile-module","features-modules-leaderboard-leaderboard-module":"features-modules-leaderboard-leaderboard-module","features-modules-team-team-module":"features-modules-team-team-module","features-modules-get-start-get-start-module":"features-modules-get-start-get-start-module","features-modules-home-home-module":"features-modules-home-home-module","features-modules-release-notes-release-notes-module":"features-modules-release-notes-release-notes-module","locales":"locales"}[chunkId]||chunkId) + "-es2015." + {"chart-js":"9b84a0875a35ce9a88ff","default~abp-ng-identity~abp-ng-setting-management~abp-ng-tenant-management":"c023253df7877299027a","abp-ng-identity":"75f3250c7a77f5ac8562","abp-ng-setting-management":"0cab210990c1f134d999","abp-ng-tenant-management":"9945bc6efbdb9add74b2","default~features-modules-authorize-authorize-module~features-modules-contest-contest-module~features~cae43e94":"b2d7693723f9a791e0fa","default~features-modules-authorize-authorize-module~features-modules-page-page-module":"8e9cc4addc088c779894","features-modules-authorize-authorize-module":"3deed7e1eb3bf67663b3","features-modules-page-page-module":"1a7bdf80ff32db841c14","default~features-modules-contest-contest-module~features-modules-leaderboard-leaderboard-module~feat~674cbcd3":"d7558cd4ff4e5fb5c3e9","default~features-modules-contest-contest-module~features-modules-problem-problem-module~features-mod~92c31d0b":"c65cef992cacec13e168","default~features-modules-contest-contest-module~features-modules-problem-problem-module~features-mod~21de2aef":"584f8180cf7d792986ea","default~features-modules-contest-contest-module~features-modules-problem-problem-module":"7c8f9cab7290e3597164","common":"75a9fba0d313eb252c50","features-modules-problem-problem-module":"f773c4be340a7d1c1718","default~features-modules-contest-contest-module~features-modules-training-training-module":"36de6ded6b27ed5e1db8","features-modules-contest-contest-module":"8be37e15e28833818907","features-modules-training-training-module":"0915ec8a2a98e2f88bdc","default~features-modules-profile-profile-module~features-modules-team-team-module":"596b35f1c8ef26fae9c4","features-modules-profile-profile-module":"bde2337bc9f75ac3899d","features-modules-leaderboard-leaderboard-module":"1dd731c46f06054bcb44","features-modules-team-team-module":"5b9d939d11cc1285c6d3","features-modules-get-start-get-start-module":"9ad922e4e47e3770222d","features-modules-home-home-module":"f081d778e57457a16d0e","features-modules-release-notes-release-notes-module":"9dd76a7c5bfa65b9729a","locales":"baee1e508d2466a1771c"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
